<template>
  <Head title="Manage Invoice" />
  
  <AppLayout>
    <div class="container-fluid">
      <div class="row justify-content-center mx-4">
        <div class="col p-0"> 
          <manage-invoice 
            :invoice-id="invoiceId" 
            :invoice="invoice" 
          />
        </div>
      </div>
    </div>
  </AppLayout>
</template>

<script setup>
import { Head } from '@inertiajs/vue3';
import AppLayout from '../../../Layouts/AppLayout.vue';

defineProps({
  invoiceId: Number,
  invoice: Object
});
</script>

